import React, {useContext, useEffect, useState} from "react";
import {SettingsContext} from "/src/SettingsContext";

import MapMarker from "@/components/MapMarker";
import {useLocation} from "react-router-dom";

export default function Map({points, onItemClick }) {

    const { tourSettings } = useContext(SettingsContext);

    const location = useLocation();

    // Load the map background
    const [mapImage, setMapImage] = useState(null);

    useEffect(() => {
        if (tourSettings.navigation.map?.map_image) {
            setMapImage(tourSettings.navigation.map?.map_image.preview_url);
        }
    }, [tourSettings])

    // Track page view
    React.useEffect(() => {
        var _paq = window._paq = window._paq || [];
        _paq.push(['setCustomUrl', location.pathname]);
        _paq.push(['setDocumentTitle', 'Points - Map']);
        _paq.push(['trackPageView']);
    }, [location])


    return (
        <div className="mt-5 flex ">
            <div className="m-auto space-y-16">

                <div className="block text-center relative w-[90%] m-auto">
                    {mapImage && <img alt="map" className="w-full" src={ mapImage }/>  }
                    {Object.entries(points).map(([pointId, point]) => (
                        <div key={pointId}>
                            { (point) && <MapMarker pointId={pointId} point={point} onClick={onItemClick}/> }
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
